import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import ScrollToTop from '../UI/ScrollToTop/ScrollToTop'
import ScrollProgress from '../ScrollProgress/ScrollProgress'
import CustomCursor from '../CustomCursor'
import PageBackdrop from '../PageBackdrop/PageBackdrop'
import styles from './Layout.module.css'

const Layout = () => {
  return (
    <div className={styles.layout}>
      <PageBackdrop />
      <CustomCursor />
      <ScrollProgress />
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  )
}

export default Layout
